import { LoadableAfterPaint } from '@confluence/loadable';

export const RestrictedPageConfirmation = LoadableAfterPaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RestrictedPageConfirmation" */ '../src/RestrictedPageConfirmation.js'
			)
		).RestrictedPageConfirmation,
});
